import React from "react";

/** Inline `**bold**` segments within a line of text. */
export function parseInlineFormatting(text) {
  if (!text) return null;
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, index) => {
    const bold = part.match(/^\*\*(.+)\*\*$/);
    if (bold) {
      return <strong key={index}>{bold[1]}</strong>;
    }
    return part;
  });
}

const SECTION_LABEL = /^\*\*(.+?)\*\*:?\s*$/;

/**
 * Renders Strapi Informacion text (# / ## headings, **section labels**, - lists, paragraphs).
 */
export function renderInformacionContent(text) {
  if (!text || typeof text !== "string") return null;

  const lines = text.split("\n");
  const elements = [];
  let currentParagraph = [];
  let currentList = [];

  const flushParagraph = () => {
    if (currentParagraph.length > 0) {
      const body = currentParagraph.join(" ");
      elements.push(
        <p key={elements.length}>{parseInlineFormatting(body)}</p>
      );
      currentParagraph = [];
    }
  };

  const flushList = () => {
    if (currentList.length > 0) {
      elements.push(
        <ul key={elements.length} className="mt-3 mb-0">
          {currentList.map((li, idx) => (
            <li key={idx}>{parseInlineFormatting(li)}</li>
          ))}
        </ul>
      );
      currentList = [];
    }
  };

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i].trim();
    if (line.startsWith("#")) {
      flushParagraph();
      flushList();
      const match = line.match(/^#+/);
      if (match) {
        const level = Math.min(match[0].length, 6);
        const headerText = line.substring(match[0].length).trim();
        elements.push(
          React.createElement(
            `h${level}`,
            { key: elements.length, className: "mt-2" },
            parseInlineFormatting(headerText)
          )
        );
      }
    } else if (SECTION_LABEL.test(line)) {
      flushParagraph();
      flushList();
      const label = line.match(SECTION_LABEL)[1].trim();
      elements.push(
        <h4
          key={elements.length}
          className="course-detail__informacion__label"
        >
          {label}
        </h4>
      );
    } else if (line.startsWith("-")) {
      flushParagraph();
      currentList.push(line.substring(1).trim());
    } else if (line === "") {
      flushParagraph();
      flushList();
    } else {
      flushList();
      currentParagraph.push(line);
    }
  }

  flushParagraph();
  flushList();

  return elements;
}
